var ProductModule = /** @class */ (function () {
    function ProductModule() {
    }
    return ProductModule;
}());
export { ProductModule };
